import { MAPS_EMBED } from "../lib/prestations";

export default function GoogleMap({ className = "" }) {
  return (
    <div data-testid="google-map" className={`rounded-2xl overflow-hidden border border-slate-200 ${className}`}>
      <iframe
        title="Zone d'intervention Le Bon Dépanneur"
        src={MAPS_EMBED}
        width="100%"
        height="100%"
        style={{ border: 0, minHeight: "320px", display: "block" }}
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      />
    </div>
  );
}
